<script setup lang="ts">
const { t } = useI18n()

const open = defineModel<boolean>('open', { default: false })

const props = withDefaults(
  defineProps<{ primaryActionPromise?: () => boolean; isEditing?: boolean }>(),
  {
    primaryActionPromise: () => true,
    isEditing: false,
  },
)

const openModal = () => {
  open.value = true
}

const closeModal = () => {
  open.value = false
  return true
}
</script>

<template>
  <div>
    <OModal
      v-model:open="open"
      :primary-action-title="t('cancel')"
      :secondary-action-title="t('return_to_configuration')"
      primary-action-enabled
      secondary-action-enabled
      :secondary-action-promise="closeModal"
      :primary-action-promise="primaryActionPromise"
      danger
      teleport
      :title="
        props.isEditing
          ? t('cancel_the_edit', ['virtual agent'])
          : t('cancel_the_creation', ['virtual agent'])
      "
    >
      <template #content>
        <span class="text-neutral-1">
          {{
            props.isEditing
              ? t('discard_changes_of', ['virtual agent'])
              : t('cancel_the_configuration_of', ['virtual agent'])
          }}
        </span>
      </template>
    </OModal>

    <slot :handle-click="openModal" />
  </div>
</template>
